<div *ngIf="this.forgotPasawordStatus === 31">
    <div class="basicrow f-lsemi roboto-r text-center">
        <div class="basicrow">
            <img width="100%" class="mc-icon" src="../../assets/images/reg-a-icon.png">
            ¿Olvidaste tu contraseña?
        </div>
    </div>
    <div class="basicrow f-reg f-black roboto-r m-top-i text-justify">
        Escoja d&oacute;nde deseas recibir la contrase&ntilde;a temporal.
    </div>

    <div class="basicrow f-reg f-black roboto-r">
        <div class="row" >
           
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" >
                <div class="optchoice roboto-r text-left" [ngClass]="{'on': this.statusOn == 1}" (click)="this.changeType(1)" style="widows: 100%">
                    <div class="checkdef">
                        <input type="radio" name="radioG1" id="radioG1" class="css-radio"  [checked]="this.statusRadio[0] == true"/><label for="radioG1" class="css-label3 radGroup1"></label>
                    </div>

                    <div class="basicrow opttext">
                        Email Registrado<br/>
                        <!-- <span class="roboto-b">{{this.hideSubscriber}}</span> -->
                        <span class="roboto-b">{{this.email | slice:0:4}}******{{this.email | slice:-8}}</span>
                    </div>
                </div>
            </div>

            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12" style="display: none;">
                <div class="optchoice roboto-r text-left"  [ngClass]="{'on': this.statusOn == 2}"(click)="this.changeType(2)">
                    <div class="checkdef">
                        <input type="radio" name="radioG2" id="radioG2" class="css-radio"[checked]="this.statusRadio[1] == true"/><label for="radioG2" class="css-label3 radGroup1"></label>
                    </div>

                    <div class="basicrow opttext">
                        N&uacute;mero Registrado<br/>
                        <!-- <span class="roboto-b">{{this.email}}</span> -->
                        <span class="roboto-b">******{{this.subscriber | slice:-4}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="basicrow m-top-i">
        <a  class="btns vcenter " (click)="this.getPasswordRecoveryBySubscriber();" [ngClass]="{'red': this.statusOn == 1|| this.statusOn == 2,'gray': this.statusOn == 0}">
            <span class="tabcell">
                Recuperar&nbsp;&nbsp;<i class="fa fa-angle-right" aria-hidden="true"></i>
            </span>
        </a>
    </div>
</div>